<template>
  <div class="select mb-3 mt-3">
    <h6 class="mb-2">Selecciona una fecha de entrega disponibles</h6>
    <div class="row">
      <div class="col">
        <label for="dates">Fechas de entrega disponibles:</label>
        <select v-model="selectedDate" id="dates" class="form-control">
          <option disabled :value="{}">Seleccionar</option>
          <option v-for="date in dates" :key="date.value" :value="date">
            {{ date.label }}
          </option>
        </select>
      </div>
      <div class="col">
        <label for="dates">Horario:</label> <br />
        <span>{{ hour }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dates: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {
    selectedDate(value) {
      this.hour = value.hour;
    }
  },
  computed: {
    delivery() {
      return this.$store.getters.delivery;
    },
    hour: {
      get() {
        return this.selectedDate.hour;
      },
      set() {}
    },
    selectedDate: {
      get() {
        return this.selected;
      },
      set(newValue) {
        this.hour = newValue.hour;
        this.$emit('selectedDate', newValue);
      }
    }
  }
};
</script>
